import React from 'react';
import PropTypes from 'prop-types';

import Banner from './Banner';
import { useBannerContext } from '../../common/contexts/BannerContext';
import { useAppContext } from '../../common/contexts/AppContext';

import { HOW_TO_ASSESS_CP_LINK } from '../../common/navigation/navigation';

const PMCPBanner = ({ studentUid }) => {
    const bannerContext = useBannerContext();
    const { classId } = useAppContext();
    const {
        actions: { hidePMCPBanner },
        isBannerVisible,
    } = bannerContext;

    const dismissHandler = () =>
        hidePMCPBanner({
            classId,
            studentUid,
        });

    const isPMCPBannerVisible = isBannerVisible(classId, studentUid, 'isPMCPBannerVisible');

    return isPMCPBannerVisible ? (
        <Banner
            isInformation
            isDismissible
            dismissHandler={dismissHandler}
            className='dashboard-section dashboard-pm-section dashboard-decrease-padding'
        >
            <div>
                <div className='dashboard-title'>¿Cuál palabra?</div>
                <div className='dashboard-text'>
                    Recomendamos evaluar a este estudiante con un formulario de monitoreo del
                    progreso de ¿Cuál palabra?. Consulte{' '}
                    <a
                        className='dashboard-maze-link'
                        href={HOW_TO_ASSESS_CP_LINK}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        aquí <i className='dashboard-navigation-link-icon' />
                    </a>{' '}
                    cómo deben completar sus estudiantes ¿Cuál palabra? por internet o cómo ingresar
                    los resultados de una medición con papel y lápiz. La frecuencia ideal para hacer
                    monitoreo del progreso con ¿Cuál palabra? es evaluar esta medición cada 6
                    semanas.
                </div>
            </div>
        </Banner>
    ) : null;
};

PMCPBanner.propTypes = {
    studentUid: PropTypes.string.isRequired,
};

export default PMCPBanner;
